export const COLOR = {
  // Dark Theme
  darkBackground: "#18191A",
  darkNavbar: "#242526",
  darkNavbarLink: "#BA8FFF",
  darkPrimary: "#a162e8",
  darkText: "#F5F6F7",
  darkTextSecondary: "#DADDE1",
  darkTags: "rgba(255,255,255, 0.7)",
  darkBorder: "rgba(255,255,255,.5)",
  darkFooter: "#1C1E21",
  // Light Theme
  lightBackground: "#F5F6F7",
  lightNavbar: "#FFFFFF",
  lightNavbarLink: "#764ABC",
  lightPrimary: "#7431CA",
  lightText: "#1C1E21",
  lightTextSecondary: "#606770",
  lightTags: "rgba(0,0,0,0.7)",
  lightBorder: "rgba(0,0,0,0.5)",
  lightFooter: "#F8F9FA",

  deepPurple300: "#9575cd",
  deepPurple400: "#7e57c2",
  deepPurple500: "#673ab7",
  deepPurple700: "#512da8",
  success100: "#c8e6c9",
  success500: "#4caf50",
  success700: "#388e3c",
  success900: "#1b5e20",
  danger100: "#ffcdd2",
  danger500: "#f44336",
  danger700: "#d32f2f",
  danger900: "#b71c1c",
};
